import rest from 'rest';
import mime from 'rest/interceptor/mime';
import errorCodeInterceptor from 'rest/interceptor/errorCode';
import pathPrefixInterceptor from 'rest/interceptor/pathPrefix';

import a15DefaultHeaders from './interceptor/a15DefaultHeaders';
import accountRouteProcessing from './interceptor/accountRouteInterceptor';
import ieCacheBuster from './interceptor/ieCacheBuster';

import { debug } from '../utils/logger';

/**
 *
 * rest.js
 * docs: https://github.com/cujojs/rest/tree/master/docs
 *
 * https://github.com/cujojs/rest/blob/master/docs/interfaces.md#interface-request
 *
 * Example usage:
 *

    client({ path: '/data.json'
             entity: { },           // Defaults to POST if set
             headers: { ... },
    }).then(function(response) {
        console.log('response: ', response);
    });
 */

/**
 * @param {Object} options        Configuration object
 * @param {String} options.prefix base url prefix
 * @param {Object} clientToWrap   rest.js client that will be wrapped by our interceptors
 * @returns {Object} a rest.js client wrapped in required interceptors
 */
export function urbnrest(options = {}, clientToWrap = rest) {
    let client = clientToWrap.wrap(mime)
                             .wrap(errorCodeInterceptor)
                             .wrap(ieCacheBuster)
                             .wrap(accountRouteProcessing)
                             .wrap(a15DefaultHeaders);

    if (options.prefix && options.prefix !== 'undefined') {
        debug(options.prefix);
        client = client.wrap(pathPrefixInterceptor, { prefix: options.prefix });
    }

    return client;
}
